const config = {
  environment: 'dev',
  api_url: 'http://localhost:5002'
};

export default config;
